<app-filters-checkbox-item
    [title]="'filters.project.organizationSkills.title' | translate"
    [option]="organizationSkillsFilterItem"
    (selectionChange)="onOrganizationSkillsSelectionChanged()"
>
</app-filters-checkbox-item>
